import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  pageTitle: {
    fontSize: 20,
    fontWeight: 700,
    color: theme.palette.text.primary,
    textAlign: 'center',
    marginBottom: theme.spacing(3),
  },
  bestChip: {
    backgroundColor: theme.palette.statusLabel.success.primary,
    color: theme.palette.white,
    fontWeight: 700,
  },
  attemptCardContent: {
    padding: theme.spacing(2, 2.5, 2.5),
  },
  remainingAttempts: {
    marginTop: theme.spacing(2),
    color: theme.palette.text.secondary,
    textAlign: 'right',
  },

  /* Navigation */
  navigation: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: theme.spacing(4),
    paddingTop: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
  },
  prevButton: {
    textTransform: 'none',
    fontWeight: 600,
    color: theme.palette.text.secondary,
    padding: theme.spacing(0.5, 3),
  },
  actionsRight: {
    display: 'flex',
    gap: theme.spacing(1.5),
  },
  retakeButton: {
    textTransform: 'none',
    fontWeight: 600,
    borderColor: theme.palette.common.black,
    color: theme.palette.common.black,
    padding: theme.spacing(0, 3),
    '&:hover': {
      opacity: 0.7,
    },
  },
  nextButton: {
    textTransform: 'none',
    fontWeight: 700,
    backgroundColor: theme.palette.common.black,
    color: theme.palette.white,
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    '&:hover': {
      backgroundColor: theme.palette.common.black,
      opacity: 0.8,
    },
  },
}))

export default useStyles
